module.exports = __webpack_public_path__ + "img/s9-5.124be1f9.jpg";